import React, { useState } from "react";
import { Badge, Grid, Icon, PlainButton } from "@culturehq/components";
import { Trans } from "app/utils";
import ErrorBoundary from "components/common/ErrorBoundary";
import StorySegment from "../analytics/StorySegment";
import TopStoryTellers from "../analytics/TopStoryTellers";
import ExternalStatus from "../analytics/ExternalStatus";
import HighestPerformingStories from "../analytics/HighestPerformingStories";
import ExternalStoriesDoughnutChart from "../analytics/ExternalStoriesDoughnutChart";
import DateRangeFilter from "./DateRangeFilter";
import TagFilter from "./TagFilter";

import "../analytics/styles.scss";
import BroadcastMessages from "./BroadcastMessages";
import ChannelFilter from "./ChannelFilter";

export const FilterByTags = ({ selectedTags }) => {
  const handleRemoveTag = option => {
    const bc = new BroadcastChannel(BroadcastMessages.ANALYTICS_TAG_FILTER_SELECT_TAGS);
    bc.postMessage({ option, selectedTags });
  };

  const handleClearAll = option => {
    const bc = new BroadcastChannel(BroadcastMessages.ANALYTICS_TAG_FILTER_CLEAR_ALL);
    bc.postMessage(null);
  };

  return (
    <div className="filter_by">
      <h4 className="Title">Filtering analytics by:</h4>
      {selectedTags.map(tag => (
        <Badge className="TagBadge" primary icon={tag.categoryIcon} onClick={() => handleRemoveTag(tag)}>
          {tag.label}
          <Icon icon="close" className="close-icon" />
        </Badge>
      ))}
      {selectedTags.length && (
        <PlainButton className="Filters__Footer--clear" onClick={handleClearAll}>
          <Trans>Clear All</Trans>
        </PlainButton>
      )}
    </div>
  );
};

const ExternalAnalytics = () => {
  const [params, setParams] = useState({
    type: "culture_page"
  });
  const [selectedTags, setSelectedTags] = useState([]);

  // eslint-disable-next-line consistent-return
  const handleFilterChange = (param, value, { selectedTags = [] } = {}) => {
    if (param === "type") return setParams(prev => ({ ...prev, [param]: value }));
    if (param !== "tags") return setParams(prev => ({ ...prev, [param]: value }));

    setSelectedTags(selectedTags);
    setParams(prev => ({
      ...prev,
      startDate: prev.startDate,
      endDate: prev.endDate,
      ...value
    }));
  };

  return (
    <div className="analytics clearfix">
      <ErrorBoundary>
        <div className="tile_main">
          <h3>
            <Trans>EXTERNAL ANALYTICS</Trans>
          </h3>
          <div className="filters">
            <DateRangeFilter onChange={handleFilterChange} />
            <ChannelFilter type={params.type} onChange={handleFilterChange} />
            <TagFilter onChange={handleFilterChange} />
          </div>
        </div>
        {!!selectedTags.length && (
          <FilterByTags selectedTags={selectedTags} />
        )}
        {params && Object.keys(params).length > 0 && (
          <>
            <ExternalStatus params={params} />
            <Grid>
              <Grid.Item md={6} lg={8}>
                <StorySegment external params={params} />
              </Grid.Item>
              <Grid.Item md={6} lg={4}>
                <TopStoryTellers external params={params} />
              </Grid.Item>
            </Grid>
            <Grid>
              <Grid.Item md={6} lg={8} className="table_wrap">
                <HighestPerformingStories params={params} />
              </Grid.Item>
              <Grid.Item md={6} lg={4}>
                <ExternalStoriesDoughnutChart params={params} />
              </Grid.Item>
            </Grid>
          </>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default ExternalAnalytics;
